import type { DoubleMaterialityIroTypeEnum } from "@green0meter/api-client";

type QuestionWithIro = {
  iro?: DoubleMaterialityIroTypeEnum | null;
};

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null;
};

const hasIro = (value: unknown): value is QuestionWithIro => {
  return isRecord(value) && "iro" in value;
};

export const getQuestionIro = (
  question: unknown,
): DoubleMaterialityIroTypeEnum | null => {
  if (!hasIro(question)) {
    return null;
  }

  return question.iro ?? null;
};
